import { Effect, Layer } from 'effect';
import { GluonConfig } from '../../../../services/gluonConfig';
import { HttpService } from '../../../../services/http';
import { GetParticles } from './gluon/requests';
import { GetAllParticlesPaginatedResolver } from './gluon/resolvers';
import { ParticleService } from './service';

export const GluonParticleService = Layer.effect(
    ParticleService,
    Effect.gen(function* (_) {
        const http = yield* _(HttpService);

        const gluonConfig = yield* _(GluonConfig);
        const gluonUrl = gluonConfig.gluonUrl;

        const getParticlesResolver = GetAllParticlesPaginatedResolver(http, gluonUrl);
        const getParticles = (tenant: string) =>
            Effect.request(GetParticles({ tenant }), getParticlesResolver);

        return { getParticles };
    }),
);
